import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import List from '../../../generic/List';
import { Badge, BadgeColors, BadgeShapes } from '../../../generic/Badge';
import styles from '../dependencies.module.less';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import type { DependencyV2Modals } from '../hooks/useDependencyModals';
import DependencyTableContents from './DependencyTableContents';
import PaginationRangeWithControl from '../../../generic/Pagination/PaginationRangeWithControl';
import useFetchDependencyAction from '../hooks/useFetchDependencyAction';

type Props = {
  modals: DependencyV2Modals;
};

const DependenciesTable: VoidFunctionComponent<Props> = ({ modals }) => {
  const isLoading = useSelector(DependenciesV2Store.selectors.getAreDependenciesLoading);
  const totalDependencyCount = useSelector(DependenciesV2Store.selectors.getTotalDependencies);

  const page = useSelector(DependenciesV2Store.selectors.getPage);
  const count = useSelector(DependenciesV2Store.selectors.getCount);
  const totalItems = useSelector(DependenciesV2Store.selectors.getTotalDependencies);

  const setPage = useFetchDependencyAction(DependenciesV2Store.actions.setPage);

  return (
    <div className={styles.DependenciesTable}>
      <List>
        <List.Header>
          <div className={styles.DependenciesTableHeader}>
            <div className={styles.DependenciesTableHeaderTitle}>
              <span className="margin-right-xs">Dependencies</span>
              <Badge shape={BadgeShapes.Circle} color={BadgeColors.LightGray}>
                {!isLoading ? totalDependencyCount : '...'}
              </Badge>
            </div>
            <div className={styles.DependenciesTableHeaderPagination}>
              <PaginationRangeWithControl
                page={page}
                count={count}
                totalItems={totalItems}
                setPage={setPage}
              />
            </div>
          </div>
        </List.Header>
        <List.Body>
          <DependencyTableContents modals={modals} />
        </List.Body>
      </List>
    </div>
  );
};

export default DependenciesTable;
